import template from './searchbox.html';
import './searchbox.scss';

export class SearchboxController {
  constructor() {
    this.text = '';
  }
  $onInit() {
    if (!this.maxLength) {
      this.maxLength = '255';
    }
  }
  search() {
    this.onSearch({ text: this.text });
  }
}

export default {
  controller: SearchboxController,
  template,
  bindings: {
    id: '@',
    onSearch: '&',
    disableSearch: '<',
    debounce: '@',
    maxLength: '@',
  },
};
